export default __webpack_public_path__ + "static/media/page-not-found.2ff1b75f.svg";